export class MerchantAccount {
  merchantAccountId?: number;
  customerId: number;
  apiKey: string;
  merchantId: string;
  terminalId: string;
  publicKey: string;
  payLinkApiKey?: string;
  payLinkMerchantId?: string;
  payLinkTerminalId?: string;
  isPayLinkWebhookRegistered?: boolean;
  created?: string;
  updated?: string;
  clearentPaymentBaseUrl?: string
  processor? : number;
  processorName? : number;
  description? : string;
  status? : boolean;
  practiceId? : number;
  practiceName? : string;
  processorType?: number;
}

export class ClearentPublicKeyResp
{
  practiceClearentPublicKey: string;
}


export class GetClearentPublicKeyForPayNowReq
{
  payNowCorrelationId : string;
  practiceId : number;
  patientId: number;
}
